import { Box } from "../../box";
import { Children, forwardRef } from "react";
import { EmbeddedIcon } from "../../icons";
import { useLink } from "./useLink";
import { NewTabIndicator } from "./NewTabIndicator";
import { as, augmentElement, mergeProps } from "../../shared";
import { useStyleProps } from "../../styling";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultElement = "a";
export function InnerIconLink(props) {
  const [styleProps] = useStyleProps("link");
  const {
    active,
    "aria-label": ariaLabel,
    as: asProp = DefaultElement,
    autoFocus,
    children,
    condensed,
    disabled,
    external,
    focus,
    forwardedRef,
    hover,
    rel,
    size,
    target,
    visited,
    variant,
    ...rest
  } = mergeProps(props, styleProps);
  const {
    linkProps,
    showNewTabIndicator
  } = useLink({
    active,
    autoFocus,
    cssModule: "o-ui-icon-link",
    disabled,
    external,
    focus,
    forwardedRef,
    hover,
    rel,
    target,
    variant,
    visited
  });
  const icon = Children.only(children);
  const iconMarkup = augmentElement(condensed ? icon : /*#__PURE__*/_jsx(EmbeddedIcon, {
    children: icon
  }), {
    size
  });
  return /*#__PURE__*/_jsxs(Box, { ...mergeProps(rest, {
      "aria-label": ariaLabel,
      as: asProp
    }, linkProps),
    children: [iconMarkup, showNewTabIndicator && /*#__PURE__*/_jsx(NewTabIndicator, {})]
  });
}
InnerIconLink.defaultElement = DefaultElement;
export const IconLink = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerIconLink, { ...props,
  forwardedRef: ref
}));
/////////
export const IconLinkAsButton = as(IconLink, "button");